import * as React from "react";
import { graphql } from "gatsby";
import { BlogPostTemplate } from "../../../components/Blog/BlogTemplate";
import { english } from "../../../context/lang/langs/englishMessages";

interface Props {
  data: {
    markdownRemark: {
      html: string;
      frontmatter: {
        date: string;
        title: string;
        slug_en: string;
        slug_es: string;
        lang: string;
        slug: string;
        image: string;
        description: string;
      };
    };
  };
}

export default function Index(props: Props) {
  return (
    <>
      <BlogPostTemplate data={props.data} lang={english} />
    </>
  );
}

export function Head(props: Props) {
  return (
    <>
      <html lang="en" />
      <meta httpEquiv="content-language" content="en-us"></meta>
      <title>{props.data.markdownRemark.frontmatter.title}</title>
      <meta
        name="description"
        content={props.data.markdownRemark.frontmatter.description}
      />
      <meta
        property="og:title"
        content={props.data.markdownRemark.frontmatter.title}
      />
      <meta
        property="og:description"
        content={props.data.markdownRemark.frontmatter.description}
      />
      <meta
        property="og:image"
        content={props.data.markdownRemark.frontmatter.image}
      />
    </>
  );
}

export const pageQuery = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        slug_en
        slug_es
        date(formatString: "MMMM DD, YYYY")
        title
        image
        description
        lang
        slug
      }
    }
  }
`;
